export default (storeState, {payload}) => {
    let newState = Object.assign({}, storeState);
    newState.comparisonData = payload;

    return newState;
};
